import { useTranslation } from "react-i18next";
import styles from "./NoSavedPlaces.module.scss";

export const NoSavedPlaces = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
      >
        <path
          d="M107.45 60C109.05 54.9 110 49.4 110 43.45C110 28 97.55 15.4999 82.2 15.4999C73.1 15.4999 65.05 19.9001 60 26.7001C54.95 19.9001 46.85 15.4999 37.8 15.4999C22.45 15.4999 10 28 10 43.45C10 78.45 42.4 99.1 56.9 104.1C57.75 104.4 58.85 104.55 60 104.55"
          stroke="#FF8C42"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.6992 105C97.5358 105 104.699 97.8365 104.699 88.9999C104.699 80.1634 97.5358 72.9999 88.6992 72.9999C79.8626 72.9999 72.6992 80.1634 72.6992 88.9999C72.6992 97.8365 79.8626 105 88.6992 105Z"
          stroke="#FF8C42"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.699 108L102.699 103"
          stroke="#FF8C42"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <h4 className={styles.title}>{t("NoSavedPlacesYet")}</h4>

      <p className={styles.description}>{t("NoSavedPlacesYetDescription")}</p>
    </div>
  );
};
